import React from "react";
import { Modal } from "@material-ui/core";
import btnClass from "../Styles";
import Close from "../../../src/assets/images/close.svg";
import { ModalProps } from "./types";
import classes from "./index.module.scss";

const MAX_WIDTH = 420;

UserModal.defaultProps = {
  maxWidth: MAX_WIDTH,
  titleSubmit: "Tiếp tục",
  titleClose: "Hủy bỏ",
};

export default function UserModal({
  title,
  titleSubmit,
  titleClose,
  styles,
  open,
  children,
  content,
  handleClose,
  handleSubmit,
  handleCloseIcon,
  buttonSubmit,
}: ModalProps) {
  return (
    <Modal disableBackdropClick open={open} className={classes.modal}>
      <div className={`${classes.container} ${styles}`}>
        <p className={classes.title}>{title}</p>
        <img
          src={Close}
          alt="close"
          className={classes.close}
          onClick={handleCloseIcon || handleClose || handleSubmit}
        />
        <div className={classes.content}>
          {children ? (
            React.Children.toArray(children)
          ) : (
            <p className={classes.pContent}>{content}</p>
          )}
          <div className={classes.action}>
            {handleClose && (
              <button className={btnClass.buttonNormal} onClick={handleClose}>
                {titleClose}
              </button>
            )}
            {buttonSubmit ||
              (handleSubmit && (
                <button className={btnClass.button} onClick={handleSubmit}>
                  {titleSubmit}
                </button>
              ))}
          </div>
        </div>
      </div>
    </Modal>
  );
}
